






import { defineComponent, computed, useRoute } from "@nuxtjs/composition-api";
import { usePageStore } from "~/stores/page";

const PRODUCT = () => import("~/modules/catalog/pages/product.vue");
const CATEGORY = () => import("~/modules/catalog/pages/category.vue");
const CMS_PAGE = () => import("~/pages/Cms.vue");

export default defineComponent({
  name: "PageResolver",
  components: {
    CATEGORY,
    CMS_PAGE,
    PRODUCT,
  },
  middleware: ["url-resolver"],

  head() {
    const baseUrl = process.env.VSF_STORE_URL || "https://canifa.com";
    const decodedPath = decodeURIComponent(this.$route.path || "");

    return {
      link: [{ rel: "canonical", href: baseUrl + decodedPath }],
    };
  },

  setup() {
    const route = useRoute();
    const { routeData } = usePageStore();
    const type = computed(() => routeData?.type);
    return { type, route };
  },
});
